function loadDevtools(client, originUrl) {
  import('./dev-tools-install')
    .then((mod) => mod.install(client, originUrl))
    // eslint-disable-next-line no-console
    .catch(() => console.error('Failed to load devtools'));
}

export { loadDevtools };
